import React, { useState } from "react";
import { useSelector } from "react-redux";
import TabsNavbar from "../../Common/TabsNavBar/TabsNavbar";
import StockStats from "./StockStats";
import CommercialStats from "./CommercialStats";
import ProductStats from "./ProductStats";
// import SupplierStats from "./SupplierStats";

// Tab labels are raw i18n keys — TabsNavbar translates internally.
const TABS = ["Stock & Logistics", "Products" /* , "Suppliers" */];

/**
 * Statistics under the catchment area map (spec "Onglet Statistique"), the
 * same for admin, reseller and business affiliate: order figures count the
 * caller's orders (server-scoped), stock / supplier figures are company-wide.
 */
const StatisticsSection = () => {
  const { user } = useSelector((state) => state.userReducer);
  const [activeTab, setActiveTab] = useState(TABS[0]);

  if (![0, 1, 2].includes(user?.attributes?.userRole)) return null;

  return (
    <div className="mt-5">
      <TabsNavbar tabs={TABS} activeTab={activeTab} setActiveTab={setActiveTab} />
      {activeTab === "Stock & Logistics" && (
        <div className="mt-3">
          <StockStats />
          <CommercialStats />
        </div>
      )}
      {activeTab === "Products" && <ProductStats />}
      {/* {activeTab === "Suppliers" && <SupplierStats />} */}
    </div>
  );
};

export default StatisticsSection;
